<template>
  <div
    v-if="color"
    class="eg-colored-dot-box"
    :style="{
      '--color-box-color': color,
      '--color-box-background-color': backgroundColor,
    }"
  />
</template>

<script>
export default {
  name: "EgColoredDotBox",

  props: {
    color: {
      type: String,
      required: true,
    },

    backgroundColor: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.eg-colored-dot-box {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--color-box-background-color);
  flex-shrink: 0;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--color-box-color);
    transform: translate(100%, 100%);
  }
}
</style>
